module.exports = __webpack_public_path__ + "img/main_home_phone_de.4ab5d20.png";